import React from 'react';
import { HardDrive, Upload, FolderOpen, Zap } from 'lucide-react';
import { FONT } from './theme';

const TABS = [
  { id: 'ingest', label: 'Ingest', icon: HardDrive },
  { id: 'upload', label: 'Upload', icon: Upload },
  { id: 'destinations', label: 'Destinations', icon: FolderOpen },
  { id: 'automations', label: 'Automations', icon: Zap },
];

// Quiet, grey, connected-underline tabs -- no colored pills, accent reserved
// for the active tab only (mirrors StreamingStepsChain's restrained palette
// rather than a busy Material-style tab bar).
export default function TabBar({ c, activeTab, setActiveTab }) {
  return (
    <div style={{ display: 'flex', gap: '4px', padding: '10px 20px 0', borderBottom: `1px solid ${c.rule}`, flexShrink: 0 }}>
      {TABS.map(({ id, label, icon: Icon }) => {
        const active = activeTab === id;
        return (
          <button
            key={id}
            onClick={() => setActiveTab(id)}
            style={{
              display: 'flex', alignItems: 'center', gap: '6px',
              padding: '8px 12px', fontFamily: FONT, fontSize: '12.5px', fontWeight: 500,
              background: 'none', border: 'none', borderBottom: `2px solid ${active ? c.accent : 'transparent'}`,
              color: active ? c.text : c.muted, cursor: 'pointer', marginBottom: '-1px',
            }}
          >
            <Icon size={13} /> {label}
          </button>
        );
      })}
    </div>
  );
}
